/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathXy = createReactComponent("outline", "math-xy", "IconMathXy", [["path", { "d": "M14 9l3 5.063", "key": "svg-0" }], ["path", { "d": "M4 9l6 6", "key": "svg-1" }], ["path", { "d": "M4 15l6 -6", "key": "svg-2" }], ["path", { "d": "M20 9l-4.8 9", "key": "svg-3" }]]);

export { IconMathXy as default };
//# sourceMappingURL=IconMathXy.mjs.map
